import React from 'react'
import CopyToDestination from '../../../../others/CopyToDestination'
import { phoneRequired, required } from '../../../../form/FormValidations'
import { Field } from 'redux-form'
import { Input, InputWithIcon, Textarea } from '../../../../form'
import { connect } from 'react-redux'
import FindingDropdowns from '../dropdown/FindingDropdowns'
import { useActiveTestType } from '../../helpers/useActiveTestType'

function FindingField(props) {
  // Field Component
  const { fieldValues, name, isRequired, showCopy, isOpen, validateArr, isPhoneInput, validate, findings, dropdownType, activeFieldType, handleFieldFocus, activeFieldKey, isHeaderModule } = props

  const activeTestType = useActiveTestType(name)

  const getComponentType = () => {
    switch (props.fieldType) {
      case 'textarea':
        return Textarea
      case 'inputWithIcon':
        return InputWithIcon
      default:
        return Input
    }
  }

  const showAddButton = findings.length == 0

  return (
    <>
      <Field
        {...props}
        label={
          <span>
            {fieldValues.custom_label} <span className="text-danger">{isRequired ? " *" : ''}</span>
            {showCopy?.destination && <CopyToDestination showCopy={showCopy} source={props.name} />}
          </span>
        }
        validate={isOpen && isRequired ? isPhoneInput ? [...validateArr, phoneRequired] : [...validateArr, required] : validate}
        labelClasses={!fieldValues.custom_label && 'mb-0 d-inline'}
        component={getComponentType()}
        // findings props
        findingAutoComplete={showAddButton}
        findingWrapperClasses="position-relative"
        FindingAutoCompleteComp={FindingDropdowns}
        findingDropdownProps={{ findings, activeTestType, dropdownType, activeFieldType, name, handleFieldFocus, activeFieldKey, isHeaderModule }}
        autoComplete="off"
      />
    </>
  )
}

const mapStateToProps = state => {
  const { examFinding } = state

  return {
    findings: examFinding.findings,
    dropdownType: examFinding.dropdownType,
    activeFieldType: examFinding.activeFieldType,
    activeFieldKey: examFinding.activeFieldKey,
  }
}

export default connect(mapStateToProps)(FindingField)